import React from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, Button } from "react-bootstrap";
import { Image } from "cloudinary-react";
import "../Styles/errorPage.css";
import SearchBar from "./Lift/SearchBar";

export default function Error() {
  return (
    <>
      <Navbar expand="md" fixed="top" variant="dark">
        <Navbar.Brand className="pl-5" href="#">
          <Link to="/lift">
            <Image
              cloudName="projectnairon"
              publicId="yconnector-asset/YConnector-Logo_dewjdd.png"
              width="40%"
              alt="YConnector logo"
              className="d-inline-block align-top"
            />
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <div className="d-md-block ml-md-auto">
            <Nav>
              <Nav.Link href="/lift-login">Login</Nav.Link>

              <Nav.Link href="/lift-create-account">
                <Button
                  style={{
                    backgroundColor: "#fff",
                    color: "#2B52BA",
                    border: "none",
                  }}
                >
                  SignUp
                </Button>
              </Nav.Link>
            </Nav>
          </div>
          <div className="ml-md-auto d-md-none mt-3">
            <Nav>
              <div className="ml-md-auto d-md-none mt-3"></div>
            </Nav>
          </div>
        </Navbar.Collapse>
      </Navbar>


      <div className="errorBody">
        <h1 className="header">Sorry! this page is not available.</h1>
        <h5 className="textBody">
          Not to worry, we got you covered, kindly use the search box below or
          visit our <Link to="/lift"><strong>homepage</strong></Link>{" "}
        </h5><br />
       
       
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="col-md-4"></div>
          <div className="col-md-4">
          <SearchBar  />
         
          <br />
        <Link to="/lift">
          <Button className="error-page-home"><strong>Visit Homepage</strong></Button>
        </Link>
          </div>
          <div className="col-md-4"></div>
        </div>
      </div>

      
    </>
  );
}
